import { OnInit } from '@angular/core';
var NewsPanelItemComponent = /** @class */ (function () {
    function NewsPanelItemComponent() {
    }
    Object.defineProperty(NewsPanelItemComponent.prototype, "className", {
        get: function () { return 'news-panel-item'; },
        enumerable: true,
        configurable: true
    });
    ;
    NewsPanelItemComponent.prototype.ngOnInit = function () {
    };
    return NewsPanelItemComponent;
}());
export { NewsPanelItemComponent };
